import { mapState } from 'vuex';
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import AppPopover from "@/components/AppPopover";
import AppIcon from "@/components/AppIcon";
import Popper from "vue3-popper";
import AppTd from "@/components/AppTd";
import WrapWithStatusIcon from "@/components/seo/WrapWithStatusIcon.vue";
export default {
  name: "SeoDescriptionCell",
  components: {
    AppIcon,
    AppPopover,
    WrapWithCopy,
    Popper,
    AppTd,
    WrapWithStatusIcon
  },
  emits: ["onEdit", "onPaste", "isCopied", "onCopyingHover", "onCopyingHoverLeave"],
  props: {
    item: Object,
    showPopover: Boolean,
    uid: String,
    index: Number
  },
  data() {
    return {
      isClicked: false
    };
  },
  computed: {
    ...mapState({
      is_copying: state => state.content.is_copying
    })
  },
  watch: {
    is_copying() {
      if (!this.is_copying) {
        this.isClicked = this.is_copying;
      }
    }
  },
  methods: {
    handleCopied() {
      const refEl = this.$refs[this.uid];
      if (!refEl) {
        return;
      }
      this.isClicked = true;
      this.$emit("isCopied", refEl);
    }
  }
};